export default function Bluetooth() {
  return (
    <div
      className="ion-icon-bluetooth"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<path d="M140,143.6c-15.9,15.9-11.7,17.3-10.6,18.4c1.1,1.1,89.8,85.6,89.8,85.6s3.9,3.4,3.9,8.4h0c0,5-3.9,8.4-3.9,8.4
		s-88.7,84.5-89.8,85.6c-1.1,1.1-5.3,2.5,10.6,18.4c15.9,15.9,18.4,12.2,19.2,11.4l67.4-64.3c0.1-0.1,0.2-0.2,0.3-0.3
		c0.1-0.1,0.3-0.2,0.4-0.3c2.3-1.9,9.8-10.6,9.8-3.2c0,7.3,0,151.8,0,156.4v0.1v1.7c0,5.5,5.2,10.1,11.6,10.1c3.5,0,6.7-1.3,8.9-3.5
		l0,0c0,0,118.2-112.8,122.8-117.2c4.6-4.4,5-10.7,1-14.7l-83.9-80.3c0,0-4.4-4.3-4.4-8.3s4.4-8.3,4.4-8.3l83.9-80.3
		c4-4,3.6-10.4-1-14.7c-4.6-4.4-122.8-117.2-122.8-117.2l0,0c-2.1-2.1-5.3-3.5-8.8-3.5c-6.4,0-11.6,4.6-11.6,10.1v1.7V44
		c0,4.6,0,149.1,0,156.4c0,7.4-7.5-1.3-9.8-3.2c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.2-0.2-0.3-0.3l-67.4-64.3
		C158.3,131.4,155.9,127.7,140,143.6z M280,119.9c0-6.6,7.5,2.3,9.8,4.4l30.5,29.2c2.1,2,2.9,4.7,2.9,7.2c0,2.5-1,5.6-2.8,7.3
		c-1.8,1.7-30.8,29.5-30.8,29.5c-2.3,1.8-9.6,9.8-9.6,1.7C280,199.2,280,126.5,280,119.9z M280,312.8c0-8.2,7.2-0.2,9.6,1.7
		c0,0,29.1,27.8,30.9,29.5c1.8,1.7,2.8,4.9,2.8,7.3s-0.8,5.2-2.9,7.2l-30.5,29.2c-2.3,2.1-9.8,11-9.8,4.4
		C280,385.5,280,312.8,280,312.8z"/>
</g>
</svg>
`,
      }}
    />
  )
}
